import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isVwnRecommendationsEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('vwnRecommendations'),
)

export default isVwnRecommendationsEnabledSelector
